import { enumToOptions } from '@app/shared/helpers';
import { WaterfallSections } from '@app/shared/models/contracts/enums/shared-enums';

export const WATERFALL_SECTION_OPTIONS = enumToOptions(WaterfallSections, undefined, true, {
  viewValue: 'Jump to section...',
  value: '',
});
